<template>
  <div class="page">
    <van-nav-bar title="公司价值榜" left-arrow @click-left="$router.back()"/>
    <van-field v-model="period" label="月份" type="month" @change="load"/>
    <van-tabs v-model="tab">
      <van-tab title="员工榜">
        <van-cell v-for="r in employees" :key="field(r,'employee_id')" :title="field(r,'rank')+'. '+field(r,'employee_name')"
                  :label="field(r,'department_name')" :value="field(r,'value_score')+' 分'"/>
      </van-tab>
      <van-tab title="项目榜">
        <van-cell v-for="r in projects" :key="field(r,'task_id')" :title="field(r,'rank')+'. '+field(r,'task_title')"
                  :label="field(r,'health')+' · '+field(r,'delivery_count')+' 次交付'" :value="field(r,'value_score')+' 分'"/>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>import api from '@/api/brand';

export default {
  data() {
    return {period: new Date().toISOString().slice(0, 7), tab: 0, employees: [], projects: []}
  }, created() {
    this.load()
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, async load() {
      try {
        [this.employees, this.projects] = await Promise.all([api.employeeRank(this.period), api.projectRank(this.period)])
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }
  }
};</script>
<style scoped>.page {
  min-height: 100vh;
  background: #f5f6f8
}</style>



// WEBPACK FOOTER //
// src/views/brand/CompanyRank.vue